export const commonParams = {
  g_tk: 5381,
  inCharset: 'utf-8',
  outCharset: 'utf-8',
  notice: 0,
  format: 'jsonp'
}

export const options = {
  param: 'jsonpCallback'
}

// 设置跨域的时候 https请求http的接口
export const HOSTURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://bird.ioliu.cn/v2/?url=http://118.89.227.245:3000';

// export const HOSTURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'http://118.89.227.245:3000';

export const ERR_OK = 0



// WEBPACK FOOTER //
// ./src/api/config.js